import { useState } from 'react';
import { toast } from '@/components/ui/sonner';
import { useAuth } from '@/hooks/useAuth';
import { authAPI } from '@/services/api';
import { formatApiError } from '@/lib/apiError';
import { AuthShell } from '@/components/layout/AuthShell';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const MIN_LEN = 8;

export default function ForcePasswordChangePage() {
  const { refreshUser, logout, lang } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < MIN_LEN) {
      toast.error(`A nova password tem de ter pelo menos ${MIN_LEN} caracteres`);
      return;
    }
    if (newPassword !== confirm) {
      toast.error('As passwords não coincidem');
      return;
    }
    if (newPassword === currentPassword) {
      toast.error('A nova password tem de ser diferente da actual');
      return;
    }
    setLoading(true);
    try {
      await authAPI.changePassword(currentPassword, newPassword);
      await refreshUser();
      toast.success('Password alterada com sucesso');
    } catch (err) {
      toast.error(formatApiError(err, 'Não foi possível alterar a password'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      lang={lang || 'pt'}
      title="Alterar password"
      description="Por segurança, tem de definir uma nova password antes de continuar."
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-1.5">
          <Label htmlFor="current">Password actual</Label>
          <Input
            id="current"
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="new">Nova password</Label>
          <Input
            id="new"
            type="password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="confirm">Confirmar nova password</Label>
          <Input
            id="confirm"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="w-full" disabled={loading} size="lg">
          {loading ? 'A alterar...' : 'Alterar password'}
        </Button>
        <Button
          type="button"
          variant="ghost"
          className="w-full"
          onClick={logout}
        >
          Terminar sessão
        </Button>
      </form>
    </AuthShell>
  );
}
